<app-loader [isVisible]="isLoading"></app-loader>

<div class="wrapper">

  <!-- Header: hidden on signup page -->
  <header class="header">
    <app-header></app-header>
  </header>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer: hidden on signup page -->
  <footer class="footer">
    <app-footer></app-footer>
  </footer>

</div>